package com.wintermar.inspection.core.ui.theme.color.palette

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val NeutralColorVariant = ColorVariant(
    n25 = Color(0xFFFCFCFD),
    n50 = Color(0xFFF9FAFB),
    n100 = Color(0xFFF2F4F7),
    n200 = Color(0xFFEAECF0),
    n300 = Color(0xFFD0D5DD),
    n400 = Color(0xFF98A2B3),
    n500 = Color(0xFF667085),
    n600 = Color(0xFF475467),
    n700 = Color(0xFF344054),
    n800 = Color(0xFF1D2939),
    n900 = Color(0xFF101828)
)
